import "flatpickr/dist/themes/material_blue.css";
import PropTypes from "prop-types";
import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import ListInvoicePosOfPhase from "../ListInvoicePosOfPhase";

const DetailPhaseInvoicePos = props => {
  const { isOpenModal, phaseId, toggleModal, t, mst } = props;
  const dispatch = useDispatch();
  const childRef = useRef();
  const { addToast } = useToasts();

  const modal = useRef(null);

  return (
    <React.Fragment>
      <Modal
        isOpen={isOpenModal}
        toggle={toggleModal}
        size="lg"
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        contentClassName="detail-data-format"
        style={{ maxWidth: "99%", height: "90vh" }}
      >
        <ModalHeader toggle={toggleModal}>Thông tin đợt hóa đơn</ModalHeader>
        <React.Fragment>
          <ModalBody>
            <Row className="d-flex justify-content-center">
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "center",
                  fontSize: "18px",
                  marginTop: "3px",
                  lineHeight: "15px",
                  alignItems: "center",
                }}
              >
                {/* <i
                  className="dripicons-clockwise text-info"
                  style={{
                    fontSize: "30px",
                    cursor: "pointer",
                  }}
                  title={"Reload thông tin"}
                  onClick={() => {
                    // dispatch(invoiceCampaignDetail(dataDetail.id));
                    // childRef?.current?.queryDataListInvoice();
                  }}
                /> */}

                <div className="text-primary">Id đợt hóa đơn: {phaseId}</div>
                {/* <div className="text-info">MST: {mst}</div> */}
                {/* <React.Fragment>
                  <div className="text-success">Đã phát hành: 100</div>
                  <div className="text-warning">Chờ phát hành: 50</div>
                  <div className="text-danger">Đã từ chối: 50</div>
                </React.Fragment> */}
              </div>
            </Row>

            <div
              ref={modal}
              className="mt-3"
              style={{
                // maxHeight: "70vh",
                overflow: "auto",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
            >
              <ListInvoicePosOfPhase
                ref={childRef}
                phaseId={phaseId}
                t={t}
              ></ListInvoicePosOfPhase>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="danger"
              className="me-2"
              onClick={toggleModal}
            >
              Đóng
            </Button>
          </ModalFooter>
        </React.Fragment>
      </Modal>
    </React.Fragment>
  );
};

DetailPhaseInvoicePos.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  phaseId: PropTypes.any,
  mst: PropTypes.any,
  t: PropTypes.any,
};

DetailPhaseInvoicePos.defaultProps = {
  isOpenModal: false,
};

export default DetailPhaseInvoicePos;
